/*
  cp-sticky-atc — barra flotante de compra en la PDP.

  Que hace:
    - Aparece deslizando desde abajo cuando el boton "Agregar al carrito"
      principal sale de pantalla, y se esconde al volver a verlo.
    - Se oculta al llegar al footer y mientras el carrito lateral esta abierto.
    - Sincroniza cantidad en ambos sentidos con el selector .qty-input de la PDP.
    - Al comprar reusa el boton real del formulario #chicken-cart-form, asi
      cart-drawer-opener.js sigue abriendo el carrito lateral como siempre.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-cp-satc]');
  if (!root) return;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var btn = root.querySelector('[data-cp-satc-add]');
  var qtyInput = root.querySelector('[data-cp-satc-qty]');
  var qtyMinus = root.querySelector('[data-cp-satc-minus]');
  var qtyPlus = root.querySelector('[data-cp-satc-plus]');
  var priceEl = root.querySelector('[data-cp-satc-price]');
  var compareEl = root.querySelector('[data-cp-satc-compare]');
  var saveEl = root.querySelector('[data-cp-satc-save]');
  var thumbEl = root.querySelector('[data-cp-satc-thumb]');

  var form = document.getElementById('chicken-cart-form');
  var mainAddBtn = form ? form.querySelector('.chicken-btn--add') : null;
  var anchor =
    (form && form.querySelector('.chicken-cart-buttons')) ||
    form ||
    document.querySelector('.chicken-cart-buttons');

  function mainQtyInput() {
    return (
      document.querySelector('.qty-input[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="chicken-cart-form"]')
    );
  }

  /* ---------------- variantes ---------------- */

  var variants = {};
  var variantsTag = root.querySelector('[data-cp-satc-variants]');
  if (variantsTag) {
    try {
      (JSON.parse(variantsTag.textContent) || []).forEach(function (v) {
        variants[String(v.id)] = v;
      });
    } catch (e) {
      /* sin datos de variante la barra igual funciona con el precio inicial */
    }
  }

  var lastVariantId = null;
  var soldOut = btn ? btn.hasAttribute('disabled') : false;

  function currentVariantId() {
    var input = form && form.querySelector('input[name="id"]');
    return input ? String(input.value) : null;
  }

  function syncVariant() {
    var id = currentVariantId();
    if (!id || id === lastVariantId) return;
    lastVariantId = id;

    var v = variants[id];
    if (!v) return;

    if (priceEl) priceEl.textContent = v.price;
    if (compareEl) {
      compareEl.textContent = v.compare_at || '';
      compareEl.hidden = !v.compare_at;
    }
    if (saveEl) {
      saveEl.textContent = v.savings || '';
      saveEl.hidden = !v.savings;
    }
    if (thumbEl && v.image) thumbEl.src = v.image;
    if (btn) {
      soldOut = !v.available;
      btn.disabled = soldOut;
      var labels = btn.querySelectorAll('[data-cp-satc-label]');
      for (var i = 0; i < labels.length; i++) {
        labels[i].textContent = v.available ? labels[i].getAttribute('data-cp-satc-label') : 'Agotado';
      }
    }
  }

  /* ---------------- cantidad ---------------- */

  function clampQty(value) {
    var n = parseInt(value, 10);
    return !n || n < 1 ? 1 : n;
  }

  function setQty(n, pushToMain) {
    var value = clampQty(n);
    if (qtyInput) qtyInput.value = value;
    if (pushToMain) {
      var main = mainQtyInput();
      if (main && clampQty(main.value) !== value) {
        main.value = value;
        main.dispatchEvent(new Event('input', { bubbles: true }));
        main.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (qtyMinus) qtyMinus.disabled = value <= 1;
  }

  function readQty() {
    return clampQty(qtyInput ? qtyInput.value : 1);
  }

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      setQty(readQty() - 1, true);
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      setQty(readQty() + 1, true);
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      setQty(qtyInput.value, true);
    });
  }

  // el selector grande de la PDP manda: si cambia alla, se refleja aca
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || t === qtyInput || !t.classList) return;
    if (t.classList.contains('qty-input') || t.getAttribute('form') === 'chicken-cart-form') {
      setQty(t.value, false);
    }
  });
  // los botones +/- de la PDP escriben .value sin emitir eventos
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.qty-btn') : null;
    if (!t) return;
    setTimeout(function () {
      var main = mainQtyInput();
      if (main) setQty(main.value, false);
    }, 0);
  });

  /* ---------------- visibilidad ---------------- */

  // Recorrido de scroll (px) en el que la barra sube: no aparece de golpe,
  // se va acomodando a medida que se desliza mas alla del boton principal.
  var REVEAL = 90;

  // Adelanto (px): la barra empieza a subir cuando al bloque real le quedan
  // estos pixeles para salir por arriba, no cuando ya salio. Con el dock
  // arriba, esto cierra el hueco en que no se ve ningun boton de compra.
  var ADELANTO = 120;

  var progress = -1;
  var atFooter = false;
  var drawerOpen = false;
  var ticking = false;
  var dockActive = false;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function measure() {
    document.documentElement.style.setProperty('--cp-satc-h', root.offsetHeight + 'px');
  }

  // cuanto se scrolleo mas alla del punto donde el boton principal sale por arriba
  function scrolledPast() {
    if (anchor) return ADELANTO - anchor.getBoundingClientRect().bottom;
    return (window.pageYOffset || document.documentElement.scrollTop || 0) - 600;
  }

  // WhatsApp y social proof suben tanto con la barra fija como con el CTA
  // flotante: siempre hay que correrlos por la altura del que este abajo
  function syncFloaters(p) {
    var on = p > 0.5 || dockActive;
    document.body.classList.toggle('cp-satc-on', on);
    if (!on) return;
    var h = p > 0.5 ? root.offsetHeight : dockEl ? dockEl.offsetHeight + 12 : 0;
    document.documentElement.style.setProperty('--cp-satc-h', h + 'px');
  }

  function paint() {
    var p = 0;
    if (!atFooter && !drawerOpen) {
      p = scrolledPast() / REVEAL;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      if (reduceMotion) p = p > 0 ? 1 : 0;
    }
    if (Math.abs(p - progress) < 0.005) return;
    progress = p;

    root.style.transform = 'translate3d(0,' + ((1 - p) * 115).toFixed(2) + '%,0)';
    root.style.opacity = p;
    root.style.visibility = p > 0.01 ? 'visible' : 'hidden';
    // se puede tocar recien cuando ya esta practicamente puesta
    root.style.pointerEvents = p > 0.6 ? 'auto' : 'none';
    root.setAttribute('aria-hidden', p > 0.6 ? 'false' : 'true');
    // los flotantes (WhatsApp, social proof) se corren a mitad de camino
    syncFloaters(p);
    if (p === 1) measure();
  }

  // durante el scroll la barra sigue al dedo; los cierres forzados (footer,
  // carrito abierto) usan la transicion larga para que no se vea seco
  function forced(fn) {
    root.classList.add('is-forced');
    fn();
    paint();
    setTimeout(function () {
      root.classList.remove('is-forced');
    }, 360);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      paint();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    measure();
    paint();
  });

  var footer = document.querySelector('.footer, #shopify-section-footer, footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        forced(function () {
          atFooter = entries[0].isIntersecting;
        });
      },
      { threshold: 0 }
    ).observe(footer);
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    var readDrawer = function () {
      forced(function () {
        drawerOpen = drawer.classList.contains('active') || drawer.classList.contains('animate');
        // el carrito abierto confirma que el producto entro: se corta el spinner
        if (drawerOpen) setLoading(false);
      });
    };
    new MutationObserver(readDrawer).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
    readDrawer();
  }

  /* ---------------- fase 1: dock de los botones reales ----------------
     El bloque real de compra (.chicken-cart-buttons) es `position: sticky;
     bottom: N` en celular, asi que flota pegado abajo mientras la columna de
     compra esta en pantalla y se asienta solo al llegar a su sitio. Aca no se
     posiciona nada: el JS solo mide en cual de los dos estados esta y mueve
     --cp-dock (0 asentado, 1 flotando) para el morph del CSS.             */

  var dockEl = anchor;
  var dockSentinel = null;
  var dockOffset = 0;
  var docked = null;

  function isMobileDock() {
    return !window.matchMedia || window.matchMedia('(max-width: 749px)').matches;
  }

  // el velo tiene que sangrar hasta el borde de pantalla: el margen exacto lo
  // sabe el layout, no el CSS
  function dockBleed() {
    if (!dockEl) return;
    var left = dockEl.getBoundingClientRect().left;
    if (left >= 0) {
      document.documentElement.style.setProperty('--cp-dock-bleed', Math.round(left) + 'px');
    }
  }

  function measureDocked() {
    if (!dockSentinel) return false;
    return dockSentinel.getBoundingClientRect().top > window.innerHeight - dockOffset;
  }

  function applyDock(state) {
    docked = state;
    dockEl.style.setProperty('--cp-dock', state ? '1' : '0');
    dockActive = state && isMobileDock();
    syncFloaters(progress < 0 ? 0 : progress);
  }

  if (dockEl) {
    document.body.classList.add('cp-dock-ready');
    dockSentinel = document.createElement('div');
    dockSentinel.className = 'cp-dock-sentinel';
    dockSentinel.setAttribute('aria-hidden', 'true');
    dockEl.insertAdjacentElement('afterend', dockSentinel);
    dockOffset = parseFloat(window.getComputedStyle(dockEl).bottom) || 0;
    dockBleed();
    applyDock(measureDocked());
    // la transicion se enciende recien en el frame siguiente: si no, el morph
    // se animaria solo al cargar la pagina
    window.requestAnimationFrame(function () {
      dockEl.classList.add('cp-dock-morph');
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var top = entries[entries.length - 1].boundingClientRect.top;
          var next = top > window.innerHeight - dockOffset;
          if (next !== docked) applyDock(next);
        },
        { rootMargin: '0px 0px ' + -dockOffset + 'px 0px', threshold: 0 }
      ).observe(dockSentinel);
    }

    window.addEventListener('resize', function () {
      dockOffset = parseFloat(window.getComputedStyle(dockEl).bottom) || 0;
      dockBleed();
      applyDock(measureDocked());
    });
  }

  /* ---------------- agregar al carrito ---------------- */

  var loadingTimer = null;

  function setLoading(state) {
    if (!btn) return;
    btn.classList.toggle('is-loading', state);
    btn.disabled = state || soldOut;
    if (loadingTimer) clearTimeout(loadingTimer);
    if (state) {
      loadingTimer = setTimeout(function () {
        setLoading(false);
      }, 2500);
    }
  }

  function fallbackAdd() {
    var id = currentVariantId() || root.getAttribute('data-cp-satc-variant');
    if (!id) return;
    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: readQty() }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        window.location.href = routeRoot + 'cart';
      });
  }

  /* ---------------- compra unica / suscripcion ----------------
     El selector de la PDP (cp-purchase-options) avisa el modo con el evento
     cpo:mode y expone precio y etiqueta de suscripcion en [data-cpo]. En modo
     suscripcion la barra dice "Suscribirme", muestra el precio con descuento
     y su boton dispara el boton real de suscripcion (que va a ZafePay). */

  var cpoRoot = document.querySelector('[data-cpo]');
  var subBtn = form ? form.querySelector('[data-cpo-sub]') : null;
  var subMode = false;

  function applyMode(mode) {
    subMode = mode === 'sub' && !!cpoRoot && !!cpoRoot.getAttribute('data-sub-price');
    if (btn) {
      btn.classList.toggle('is-sub', subMode);
      var labels = btn.querySelectorAll('[data-cp-satc-label]');
      for (var i = 0; i < labels.length; i++) {
        var base = labels[i].getAttribute('data-cp-satc-label');
        var sub = labels[i].classList.contains('cp-satc__btn-label--short')
          ? 'Suscribirme'
          : cpoRoot.getAttribute('data-sub-label') || 'Suscribirme';
        labels[i].textContent = soldOut ? 'Agotado' : subMode ? sub : base;
      }
    }
    var v = variants[currentVariantId()];
    if (subMode) {
      if (priceEl) priceEl.textContent = cpoRoot.getAttribute('data-sub-price');
      if (compareEl) {
        compareEl.textContent = v ? v.price : '';
        compareEl.hidden = !v;
      }
      if (saveEl) {
        saveEl.textContent = cpoRoot.getAttribute('data-sub-save') || '';
        saveEl.hidden = !saveEl.textContent;
      }
    } else if (v) {
      lastVariantId = null;
      syncVariant();
    }
  }

  document.addEventListener('cpo:mode', function (e) {
    applyMode(e && e.detail ? e.detail.mode : 'once');
  });

  if (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      setQty(readQty(), true);
      setLoading(true);

      if (subMode && subBtn && !subBtn.disabled) {
        // suscripcion: mismo destino que el boton "Suscribirme" de la ficha
        subBtn.click();
        return;
      }

      if (mainAddBtn && !mainAddBtn.disabled) {
        // reusa el submit real: cart-drawer-opener.js lo intercepta y abre el drawer
        mainAddBtn.click();
      } else {
        fallbackAdd();
      }
    });
  }

  // apenas se abre el carrito lateral, la barra sale del estado cargando
  ['cart:updated', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      setLoading(false);
    });
  });

  /* ---------------- arranque ---------------- */

  form && form.addEventListener('change', syncVariant);
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (ev) {
    document.addEventListener(ev, syncVariant);
  });
  if (form) {
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && 'MutationObserver' in window) {
      new MutationObserver(syncVariant).observe(idInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
    }
  }

  lastVariantId = currentVariantId();
  var main0 = mainQtyInput();
  setQty(main0 ? main0.value : 1, false);
  // el evento cpo:mode de la carga pudo dispararse antes que este script
  var checked0 = document.querySelector('input[name="cpo_mode"]:checked');
  if (checked0) applyMode(checked0.value);
  measure();
  paint();
  // la altura real solo se conoce cuando cargan fuentes e imagen
  window.addEventListener('load', function () {
    measure();
    paint();
  });
})();
